import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["languageSelect"]

  connect() {
    this.subscribeToStream()
  }

  disconnect() {
    this.unsubscribeFromStream()
  }

  subscribeToStream() {
    const requestId = this.element.dataset.webhookRequestId
    if (!requestId) return

    this.streamName = `webhook_request_${requestId}`
  }

  unsubscribeFromStream() {
    this.streamName = null
  }

  generateHandler(event) {
    const language = this.hasLanguageSelectTarget
      ? this.languageSelectTarget.value
      : "ruby"

    const form = event.target.closest("form")
    if (form) {
      const input = form.querySelector("input[name='language']")
      if (input) {
        input.value = language
      }
    }
  }
}
